import QRCode from 'react-qr-code'
import { Button } from './Button'
import { useTranslation } from 'react-i18next'
import { useState, useEffect } from 'preact/hooks'
import { Copy } from 'lucide-preact'

interface QrCodeProps {
  qrCode?: string
  className?: string
}

export function QrCode({ qrCode, className = '' }: QrCodeProps) {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)

  const onCopyCode = async () => {
    if (!qrCode) return

    try {
      await window.navigator.clipboard.writeText(qrCode)
      setCopied(true)
    } catch {
      // ignore - copying failed; keep UX silent
    }
  }

  useEffect(() => {
    if (!copied) return
    const id = window.setTimeout(() => setCopied(false), 3000)
    return () => clearTimeout(id)
  }, [copied])

  return (
    <>
      <div className={`flex flex-col items-center ${className}`}>
        <div className='flex justify-center mb-6'>
          <div
            style={{
              height: 'auto',
              margin: '0 auto',
              maxWidth: 400,
              width: '100%',
            }}
          >
            {/* @ts-expect-error - react-qr-code type issue */}
            <QRCode
              size={256}
              style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
              value={qrCode}
              viewBox={`0 0 256 256`}
            />
          </div>
        </div>

        <div className='flex justify-center mt-6'>
          <Button onClick={onCopyCode} type='secondary' size='md'>
            <div className='flex gap-2 items-center'>
              <Copy />
              {t('qrCode.copyCode')}
            </div>
          </Button>
        </div>
      </div>

      {/* Transient confirmation snackbar */}
      <div aria-live='polite' className='pointer-events-none'>
        <div
          className={`fixed left-1/2 -translate-x-1/2 bottom-8 transition-opacity duration-200 ${copied ? 'opacity-100' : 'opacity-0'} bg-gray-900 text-white px-4 py-2 rounded-md shadow-lg`}
          role='status'
        >
          {t('qrCode.copyConfirmation')}
        </div>
      </div>
    </>
  )
}
